<script setup lang="ts">
import PageHeader from '@/components/PageHeader.vue'

withDefaults(defineProps<{ title: string, description: string, stickyFilters?: boolean }>(), { stickyFilters: false })

const STICKY_FILTERS_CLASSES = 'min-[992px]:sticky min-[992px]:top-2.5 min-[992px]:z-[1] min-[992px]:h-[calc(100vh-20px)] min-[992px]:self-start min-[992px]:overflow-y-auto'
</script>

<template>
  <div class="container min-h-screen pb-12">
    <PageHeader :title="title" :subtitle="description">
      <slot name="banner" />
    </PageHeader>

    <div class="flex flex-col gap-6 min-[992px]:flex-row">
      <aside
        aria-label="Filters"
        class="space-y-3 min-[992px]:w-[213px] min-[992px]:flex-none xl:w-[263px]"
        :class="{ [STICKY_FILTERS_CLASSES]: stickyFilters }"
      >
        <slot name="filters" />
      </aside>

      <section aria-label="Results" class="min-w-0 flex-1">
        <slot />
      </section>
    </div>
  </div>
</template>
